import http from './http'

export function getAssets(classAssetsTypes, accessToken) {
	return http({
		method: 'GET',
		// eslint-disable-next-line max-len
		url:  `/rest/assets?filter[type]=${classAssetsTypes}&filter[limit]=450&filter[sortby]=platform&filter[visible]=1&filter[isTradeable]=1&filter[orderby]=ASC${accessToken ? `&access_token=${accessToken}` : ''}`
	})
}
export function setFavorite(favorite, accessToken) {
	return http({
		data: favorite,
		method: 'POST',
		url: `/rest/assets/bookmarks?access_token=${accessToken}`
	})
}

export function getLotSizesApi() {
	return http({
		method: 'GET',
		url: '/rest/asset/lotsizes'
	})
}

export function getTradeSizesApi() {
	return http({
		method: 'GET',
		url: '/rest/asset/tradesizes'
	})
}

export function getTradingHours() {
	return http({
		method: 'GET',
		url: '/rest/asset/tradinghours?timestamp='+Math.round(new Date().getTime()/1000)
	})
}

export function refreshAsset(url, assetArray) {
	return http({
		data: 'assetSoId='+ JSON.stringify(assetArray),
		method: 'POST',
		url: url
	})
}

export function getDataToHighChart(
	pricerLink, pricerPort, assetName, nowTimeInSeconds, assetType, riskData, delayPricer, userId, brandName
) {
	return http({
		method: 'GET',
		// eslint-disable-next-line max-len
		url: pricerLink+':'+pricerPort+'/history?symbol='+assetName+'&resolution=1&from='+(nowTimeInSeconds-2100)+'&to='+nowTimeInSeconds+'&userId='+userId+'&assetType='+assetType+'&riskName='+riskData+'&brandName='+brandName+'&delay='+delayPricer
	})
}

